import { EquipementInvervention } from '@/models/EquipementInvervention';
import { EquipementItems } from '@/models/EquipementItems';
import { EtatEquipement } from '@/models/EtatEquipement';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { EquipementState } from './Equipement';
import { TableHeader } from '@/models/TableHeader';
import { SortType } from '@/models/SortType';

export const getters: GetterTree<EquipementState, RootState> = {
    getEquipementList(state): EquipementItems[] {
        return state.equipement;
    },
    getEquipementFilter(state): string {
        return state.equipementFilter;
    },
    getGroupeFilter(state): string {
        return state.groupeFilter;
    },
    getSsGroupeFilter(state): string {
        return state.ssGroupeFilter;
    },

    getEquipementInterventions(state): EquipementInvervention[] {
        return state.interventions;
    },
    getPage(state): number {
        return state.page;
    },
    getNumberOfPages(state): number {
        return state.numberOfPages;
    },
    getIsLoadingInterventions(state): boolean {
        return state.isLoadingInterventions;
    },
    getIsLoading(state): boolean {
        return state.isLoading;
    },
    getEtats(state): EtatEquipement[]{
        return state.etatsEquipement;
    },
    getScroll(state): number{
        return state.scroll;
    },
    getTableHeader(state): TableHeader[]{
        return state.tableHeader;
    },
    getSort(state): {sortData: string; sortStatus: SortType; } {
        return state.sort;
    },
};
